<template>
    <div class="top-details-root">
        <div class="center d-flex align-items-center h-100">
            <div
                v-if="location"
                class="detail-item d-flex align-items-center white mr-3"
            >
                <BaseIcon name="map-marker-alt" />
                <h6 class="white m-0 pl-1 font-weight-bold">{{ location }}</h6>
            </div>
            <div
                v-if="time"
                class="detail-item d-flex align-items-center white mr-1"
            >
                <BaseIcon name="clock" />
                <h6 class="white m-0 pl-1 font-weight-bold">{{ time }}</h6>
            </div>
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    props: {
        location: String,
        time: String,
    },
};
</script>

<style scoped>
.top-details-root {
    height: 32px;
    color: white !important;
}
.center {
    max-width: var(--grid-width);
    margin: auto;
}
.icon {
    max-width: 24px;
}

@media only screen and (max-width: 600px) {
    .center {
        justify-content: center;
    }

    .detail-item > span {
        font-size: 18px !important;
    }
}
</style>
